import { all, fork } from "redux-saga/effects";

import homeSagas from "../home/sagas";
import prizeSagas from "../prize/sagas";

export default function* rootSaga() {
  yield all([fork(homeSagas), fork(prizeSagas)]);
}
